document.addEventListener('DOMContentLoaded', () => {
    const originalAddEventListener = EventTarget.prototype.addEventListener;
    const originalRemoveEventListener = EventTarget.prototype.removeEventListener;

    EventTarget.prototype.addEventListener = function (type, listener, options) {
        if (type === 'DOMNodeInserted') {
            // console.warn('Intercepted DOMNodeInserted event. Replacing with MutationObserver.');
            return;
        }
        originalAddEventListener.call(this, type, listener, options);
    };

    EventTarget.prototype.removeEventListener = function (type, listener, options) {
        if (type === 'DOMNodeInserted') {
            // console.warn('Intercepted DOMNodeInserted event removal. Ignoring.');
            return;
        }
        originalRemoveEventListener.call(this, type, listener, options);
    };
});
